import { render, staticRenderFns } from "./help-detail.vue?vue&type=template&id=18f35536&scoped=true&"
import script from "./help-detail.vue?vue&type=script&lang=ts&"
export * from "./help-detail.vue?vue&type=script&lang=ts&"
import style0 from "./help-detail.vue?vue&type=style&index=0&id=18f35536&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f35536",
  null
  
)

export default component.exports